import { render, staticRenderFns } from "./AddRecords.vue?vue&type=template&id=2f8b0efe&scoped=true"
import script from "./AddRecords.vue?vue&type=script&lang=js"
export * from "./AddRecords.vue?vue&type=script&lang=js"
import style0 from "./AddRecords.vue?vue&type=style&index=0&id=2f8b0efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b0efe",
  null
  
)

export default component.exports